import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { InvestmentViewMode } from "@/domain/types";

interface InvestmentViewModeState {
	viewMode: InvestmentViewMode;
	setViewMode: (mode: InvestmentViewMode) => void;
	reset: () => void;
}

export const useInvestmentViewModeStore = create<InvestmentViewModeState>()(
	devtools(
		(set) => ({
			viewMode: "kanban",
			setViewMode: (mode) => set({ viewMode: mode }),
			reset: () => set({ viewMode: "kanban" }),
		}),
		{ name: "InvestmentViewModeStore" },
	),
);
